module.exports = __webpack_public_path__ + "img/front1.3c420e1d.png";